<template>
  <div class="outArgicProduct">
    <div class="outArgicProduct-header">
      <el-input
        class="keyword-ipt"
        v-model="keyword"
        placeholder="请输入名称或登记证号搜索"
        @input="handleChange"
      ></el-input>
    </div>
    <div class="outArgicProduct-content" ref="scrollview" v-loading="loading">
      <!-- 列表 -->
      <ul class="card-list-wrapper" v-show="receivedAgriResList.length">
        <li
          class="card-item"
          :class="{ selected: isSelected(item.agriResId) }"
          v-for="item in receivedAgriResList"
          :key="item.id"
          @click="handleSelectRes(item)"
        >
          <img
            class="agrires-img"
            :src="item.firstAgriResCategoryImgUrlBig"
            alt=""
          />
          <div class="info">
            <div class="name">
              <p class="agrires-name" :title="item.agriResName">
                {{ item.agriResName }}
              </p>
              <p class="productor-name" :title="item.productor">
                {{ item.productor }}
              </p>
            </div>
            <div class="nums">
              <p>规格：{{ item.skuName }}</p>
              <p>
                待使用量：<span
                  :class="{
                    noStock:
                      item.stockValueInPack == 0 && item.stockValueInMeter == 0,
                  }"
                  >{{ calcStockByPack(item)
                  }}{{ item.agriResPackUnitName }}</span
                ><span v-show="item.stockValueInMeter !== 0"
                  >（共{{ item.stockValueInMeter
                  }}{{ item.agriResMeterUnitName }}）</span
                >
              </p>
            </div>
          </div>
          <span class="selected-status"
            ><i class="iconfont icon-gou1"></i
          ></span>
        </li>
      </ul>

      <!-- 列表无数据 -->
      <div v-if="!receivedAgriResList.length && !keyword" class="no-list-data">
        <p class="title">暂无已出库待使用的农资</p>
        <p class="desc-txt">
          若要使用已出库待使用的农资，请在【农资库存管理】页面对农资进行出库
        </p>
        <div class="step-box">
          <div class="step-item">
            <span class="num">1</span>
            <p>
              <span class="action">农资入库</span>
              <span class="desc">在农资库存管理页面选择农资进行入库</span>
            </p>
          </div>
          <p class="line"></p>
          <div class="step-item">
            <span class="num">2</span>
            <p>
              <span class="action">农资出库</span>
              <span class="desc"
                >对已入库农资进行出库，选择“<i>领用出库</i>”</span
              >
            </p>
          </div>
          <p class="line"></p>
          <div class="step-item">
            <span class="num">3</span>
            <p>
              <span class="action">农事使用</span>
              <span class="desc">使用“已出库待使用的农资”，并输入使用量</span>
            </p>
          </div>
        </div>
        <p class="no-data-tips" @click="dialogVisible = true">
          已出库农资，但未显示？
        </p>
      </div>

      <!-- 搜索无数据 -->
      <div v-if="!receivedAgriResList.length && keyword" class="no-search-res">
        <div class="no-resources-pic"></div>
        <p class="title">没有找到该农资</p>
        <p class="desc">请检查搜索关键字，再尝试搜索</p>
      </div>
    </div>
    <el-dialog
      title="已出库农资，但未显示"
      append-to-body
      :show-close="false"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <p>
        如果您选择的农事是“施肥”，此处仅展示已认领出库的肥料。如果您选择的农事是“用药”，此处仅展示已认领出库的农药。
      </p>
      <p>因此，请确认您选择了正确的农事类型。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAgriResReceiveSkuList } from "@/api/request/snkd.produce";
import initBScroll from "@/utils/bScroll";
import { getStorage } from "@/utils/storage";
export default {
  data() {
    return {
      keyword: "",
      page: 1,
      receivedAgriResList: [],
      totalCount: 0,
      loading: false,
      dialogVisible: false,
      companyId: "",
      farmId: "",
    };
  },
  props: {
    selectedList: {
      type: Array,
      default: () => [],
    },
    sysMissionCategoryId: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.loading = true;
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }

    this.getList();
    this.$nextTick(() => {
      // 我的农资库初始化
      this.cardScroll = initBScroll(this.$refs.scrollview, {
        mouseWheel: true,
        click: true,
        pullUpLoad: {
          threshold: 30,
        },
        scrollbar: {
          fade: true,
          interactive: false,
        },
      });
      this.cardScroll.on("pullingUp", () => {
        if (this.receivedAgriResList.length < this.totalCount) {
          this.page = this.page + 1;
          this.loading = true;
          this.getReceivedAgriResList();
        }
      });
    });
  },
  methods: {
    getList() {
      const params = {
        companyId: this.companyId,
        farmId: this.farmId,
        firstAgriCategoryId: this.sysMissionCategoryId,
        pageNo: this.page,
        pageSize: 50,
      };
      if (this.keyword) {
        params.keyword = this.keyword;
      }
      getAgriResReceiveSkuList(params).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.receivedAgriResList = obj.list || [];
          this.totalCount = obj.totalCount;
        }
        this.loading = false;
      });
    },
    // 是否已经选择
    isSelected(agriResId) {
      return this.selectedList.some(function (v) {
        return v.agriResId === agriResId;
      });
    },
    // 选择农资
    handleSelectRes(item) {
      let newItem = {
        ...item,
        agriResId: item.agriResId,
        agriResSkuReceiveId: item.id,
        dosageType: 2, //写死2
        dose: "",
      };
      this.$emit("select-farm-res", newItem);
    },
    // 根据包装单位计算库存
    calcStockByPack(info) {
      return parseFloat(
        (info.stockValueInMeter / info.skuSpecValue).toFixed(1)
      );
    },
    handleChange() {
      this.page = 1;
      this.loading = true;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.outArgicProduct {
  .outArgicProduct-header {
    .keyword-ipt {
      width: 240px;
    }
  }
  .outArgicProduct-content {
    height: 480px;
    overflow: hidden;
    .card-list-wrapper {
      display: flex;
      -webkit-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      padding-top: 16px;
      padding-bottom: 35px;
      .card-item {
        position: relative;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        width: 456px;
        height: 120px;
        padding: 0 20px;
        margin-bottom: 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-box-shadow: 0 5px 20px rgba(85, 85, 124, 0.13);
        box-shadow: 0 5px 20px rgba(85, 85, 124, 0.13);
        border-radius: 20px;
        background: #ffffff;
        cursor: pointer;
        overflow: hidden;
        .agrires-img {
          width: 80px;
          height: 80px;
          border-radius: 10px;
          margin-right: 20px;
        }
        .info {
          display: flex;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          flex-direction: column;
          -webkit-box-pack: justify;
          -webkit-justify-content: space-between;
          -ms-flex-pack: justify;
          justify-content: space-between;
          height: 90px;
          .nums {
            font-size: 12px;
            font-weight: 400;
            color: #888888;
            p {
              height: 16px;
              line-height: 16px;
            }
            p:first-child {
              margin-bottom: 4px;
            }
            span {
              color: #64c3a4;
              &.noStock {
                color: #ff831e;
              }
            }
          }
          .name {
            .agrires-name {
              width: 315px;
              height: 22px;
              line-height: 22px;
              margin-bottom: 2px;
              font-weight: 500;
              font-size: 16px;
              color: #333333;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .productor-name {
              width: 315px;
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              color: #b2b2b2;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
        .selected-status {
          display: none;
          position: absolute;
          bottom: 0;
          right: 0;
          width: 0;
          height: 0;
          border: 28px solid transparent;
          border-right: 28px solid #64c3a4;
          border-bottom: 28px solid #64c3a4;
          .iconfont {
            color: #fff;
            font-size: 18px;
            position: absolute;
            top: -1px;
            left: 3px;
          }
        }
        &:hover {
          border: 1px solid #64c3a4;
          .info .name .agrires-name {
            color: #64c3a4;
          }
        }
        &.selected {
          border: 1px solid #64c3a4;
          .selected-status {
            display: block;
          }
        }
      }
      .card-item:nth-child(odd) {
        // margin-left: 30px;
      }
      .card-item:nth-child(even) {
        margin-left: 20px;
      }
    }
    .no-search-res {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 110px;
      .no-resources-pic {
        width: 50px;
        height: 62px;
        background: url("../../../assets/images/aviatFarmingList/no-resources.png")
          100% 100% no-repeat;
      }
      .title {
        width: 98px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin: 19px 0 12px;
      }
      .desc {
        width: 255px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 18px;
        text-align: center;
      }
    }
    .no-list-data {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title {
        margin-top: 135px;
        font-size: 24px;
        line-height: 32px;
        color: #333333;
        margin-bottom: 8px;
      }
      .desc-txt {
        font-size: 16px;
        line-height: 21px;
        text-align: center;
        color: #666666;
      }
      .step-box {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 36px;
        .step-item {
          display: flex;
          align-items: center;
          .num {
            display: inline-block;
            width: 32px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 15px;
            box-sizing: border-box;
            border: 1px solid #e6e6e6;
            border-radius: 50%;
            margin-right: 8px;
            color: #c9c9c9;
          }
          p {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .action {
              color: #333333;
              font-size: 16px;
              line-height: 24px;
              font-weight: 500;
            }
            .desc {
              color: #b2b2b2;
              font-size: 12px;
              line-height: 16px;
              margin-top: 4px;
              i {
                color: #64c3a4;
              }
            }
          }
        }
        .line {
          width: 30px;
          height: 1px;
          background: #e6e6e6;
          margin: 0 10px;
        }
      }
      .no-data-tips {
        position: absolute;
        bottom: 30px;
        left: 0;
        width: 100%;
        text-align: center;
        color: #cccccc;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  .dialog-txt {
    font-size: 14px;
    color: #666666;
    line-height: 1.6;
  }
}
</style>
